var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"magnifier-container"},[_vm._t("default"),_c('span',{ref:"magnificationElement",staticClass:"preview",style:({backgroundImage:'url(' + _vm.src + ')'})},[_c('span',{ref:"glass",staticClass:"magnifying-glass",style:(_vm.glassStyle)})])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }